import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bc0d3fee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bc0d3fee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0d3fee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc0d3fee')) {
      api.createRecord('bc0d3fee', component.options)
    } else {
      api.reload('bc0d3fee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bc0d3fee&scoped=true", function () {
      api.rerender('bc0d3fee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/customerCSG/index.vue"
export default component.exports